var _rect, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTesla(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 26,
    height: 26,
    rx: 13,
    fill: "#E82127"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_305_19558)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.001 21.7239L15.5471 7.40459C17.974 7.40459 18.7395 7.67071 18.85 8.75693C18.85 8.75693 20.478 8.14991 21.2991 6.91707C18.0949 5.43231 14.8754 5.36535 14.8754 5.36535L12.9968 7.65349L13.001 7.6532L11.1224 5.36499C11.1224 5.36499 7.90286 5.43202 4.6991 6.91678C5.51949 8.14963 7.14814 8.75665 7.14814 8.75665C7.25931 7.67035 8.02387 7.40423 10.4344 7.40251L13.001 21.7239Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13 4.70442C15.5901 4.68461 18.5548 5.10511 21.5898 6.42788C21.9954 5.69778 22.0997 5.3751 22.0997 5.3751C18.7821 4.06252 15.6751 3.61332 12.9996 3.60205C10.3243 3.61332 7.2175 4.06259 3.90027 5.3751C3.90027 5.3751 4.04826 5.77256 4.40983 6.42788C7.44422 5.10511 10.4094 4.68461 12.9996 4.70442H13Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_305_19558"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 19,
    fill: "white",
    transform: "translate(3 3.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTesla);
export default __webpack_public_path__ + "static/media/tesla.a5453bb06480063c0b7d188f0ee799d8.svg";
export { ForwardRef as ReactComponent };